import { FC, HTMLAttributes } from 'react';

import { Flex } from 'antd';
import cn from 'classnames';

import { ChannelAvatar } from 'entities/Channel';
import { PlannerPost } from 'features/Planner';

import styles from './PlannerPosts.module.scss';

interface IPlannerPostsProps extends HTMLAttributes<HTMLDivElement> {
	posts: PlannerPost[];
	vertical?: boolean;
	isDay?: boolean;
}

export const PlannerPosts: FC<IPlannerPostsProps> = ({ className, posts, vertical, isDay, ...props }) => {
	return (
		<Flex
			{...props}
			vertical={vertical}
			className={cn(styles.posts, className, { [styles.vertical]: vertical, [styles.isDay]: isDay })}>
			{posts.slice(0, 3).map((post) => {
				const channel = post.channels[0];
				const size = vertical ? 26 : 22;

				return (
					<div className={styles.post} key={post.id}>
						<ChannelAvatar name={channel.name} logo={channel.logo_file_path} size={size} />
					</div>
				);
			})}
			{posts.length > 3 && <div className={cn(styles.post, styles.more)}>+{posts.length - 3}</div>}
		</Flex>
	);
};
